import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CopyIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M17.02 16.44V5.64H8.82V4.08H18.58V16.44H17.02ZM5.42 19.84V7.48H15.08V19.84H5.42ZM6.98 18.28H13.52V9.04H6.98V18.28Z" />
    </SvgIcon>
  );
});
